import { EntityDragEvent } from './../ng3/controls/mouse/mouse-entity.service';
import { BoundingBox2FromCenterSize } from './../ng3/share/boundingbox2';
import { LineModel, Plane2Model, CrossLineModel } from './../ng3/model';
import { map, filter, tap } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Vector3, Vector2 } from 'three';
import { EntityStoreService } from '../entity-store/entity-store.service';

export interface CrossLine {
  vertical: LineModel;
  horizontal: LineModel;
}

export type View = 'x' | 'y' | 'z';

export interface LineInputModel {
  id: string;
  position: Vector3;
  view: View;
  crosslineLength: number;
}

@Component({
  selector: 'ng3-cross-line',
  templateUrl: './cross-line.component.html',
  styleUrls: ['./cross-line.component.css'],
  providers: [EntityStoreService],
})
export class CrossLineComponent {
  model$ = new Observable<Plane2Model>();
  posX = 0.0;
  posY = 0.0;
  private imageSubject = new BehaviorSubject<Plane2Model>(
    new Plane2Model(
      new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(200, 200)),
      10,
      undefined,
      new Vector3(0, 0, 0),
      true,
      0.0,
      true,
    ),
  );
  image$ = this.imageSubject.asObservable();

  // models_bak$: Observable<CrossLine>;
  models$: Observable<CrossLine>;
  lineTest = new LineModel(new Vector3(0, 0, 0), new Vector3(10, 10, 0));
  models: CrossLine = {
    vertical: this.lineTest,
    horizontal: this.lineTest,
  };
  // private lineSubject = new BehaviorSubject<LineInputModel>({
  //   id: 'testLine',
  //   position: new Vector3(0, 2, 30),
  //   view: 'x',
  //   crosslineLength: 1.5,
  // });
  private crosslineSubject = new BehaviorSubject<CrossLineModel>(
    new CrossLineModel(new Vector3(0, 2, 30), 'z', 1.5),
  );
  // line$ = this.lineSubject.asObservable();
  crossline$ = this.crosslineSubject.asObservable();
  @Output() drag = new EventEmitter<EntityDragEvent>();
  // @Output() modelChanged: EventEmitter<Vector3> = new EventEmitter<Vector3>();
  @Input() z = 0;
  // @Input() viewInput: View = 'x';

  // @Input()
  // get model_bak(): LineInputModel {
  //   return this.lineSubject.value;
  // }

  // set model_bak(b: LineInputModel) {
  //   this.lineSubject.next(b);
  // }
  @Input()
  get model(): CrossLineModel {
    return this.crosslineSubject.value;
  }

  set model(b: CrossLineModel) {
    this.crosslineSubject.next(b);
  }

  constructor() {
    // this.models_bak$ = this.line$.pipe(
    //   filter(m => m !== undefined),
    //   map(m => this.addCrossLines(m)),
    // );
    this.models$ = this.crossline$.pipe(
      filter(m => m !== undefined),
      // tap(m => console.log(m)),
      map(m => this.plotCrossLine(m)),
      // tap(m => console.log(m)),
    );
  }

  plotCrossLine(m: CrossLineModel) {
    this.updatePos(m);
    this.model$ = this.image$.pipe(
      map(() => {
        return new Plane2Model(
          new BoundingBox2FromCenterSize(
            new Vector2(this.posX, this.posY),
            new Vector2(m.lineWidth * 5, m.lineWidth * 5),
          ),
          // undefined,
          // new Vector3(0, 0, 0),
          // true,
          // 0.0,
          // false,
        );
      }),
    );
    // this.models$.pipe(map(m => ))
    this.models.vertical = new LineModel(
      new Vector3(this.posX + 80, this.posY, this.z),
      new Vector3(this.posX - 80, this.posY, this.z),
      'Solid',
    );
    this.models.horizontal = new LineModel(
      new Vector3(this.posX, this.posY - 80, this.z),
      new Vector3(this.posX, this.posY + 80, this.z),
      'Solid',
    );
    // this.modelChanged.emit(m.position);
    return this.models;
  }

  // addCrossLines(m: LineInputModel) {
  //   this.updatePos_bak(m);
  //   this.model$ = this.image$.pipe(
  //     map(() => {
  //       return new Plane2Model(
  //         new BoundingBox2FromCenterSize(
  //           new Vector2(this.posX, this.posY),
  //           new Vector2(m.crosslineLength * 10, m.crosslineLength * 10),
  //         ),
  //         undefined,
  //         new Vector3(0, 0, 0),
  //         true,
  //         0.0,
  //         false,
  //       );
  //     }),
  //   );
  //   // this.models.Vertical = m;
  //   // if (m !== undefined) {
  //   //   if (m.start.x === m.end.x) {
  //   //     this.models.Horizontal = new LineModel(new Vector3(m.start.x - Math.abs(m.start.y - m.end.y) / 2, m.start.y / 2 + m.end.y / 2,
  //   //       m.start.z), new Vector3(m.start.x + Math.abs(m.start.y - m.end.y) / 2, m.start.y / 2 + m.end.y / 2, m.end.z), m.style);
  //   //   } else {
  //   //     this.models.Horizontal = new LineModel(new Vector3(m.start.x / 2 + m.end.x / 2, m.start.y - Math.abs(m.start.x - m.end.x) / 2,
  //   //       m.start.z), new Vector3(m.start.x / 2 + m.end.x / 2, m.start.y + Math.abs(m.start.x - m.end.x) / 2, m.end.z), m.style);
  //   //   }
  //   // }
  //   this.models.vertical = new LineModel(
  //     new Vector3(this.posX + 80, this.posY, this.z),
  //     new Vector3(this.posX - 80, this.posY, this.z),
  //     'Dashed',
  //   );
  //   this.models.horizontal = new LineModel(
  //     new Vector3(this.posX, this.posY - 80, this.z),
  //     new Vector3(this.posX, this.posY + 80, this.z),
  //     'Dashed',
  //   );
  //   this.modelChanged.emit(m.position);
  //   return this.models;
  // }

  onDragEvent(d: EntityDragEvent) {
    this.drag.emit(d);
  }

  ngOnDestroy(): void {
    this.imageSubject.complete();
    // this.lineSubject.complete();
    this.crosslineSubject.complete();
  }

  updatePos(m: CrossLineModel) {
    switch (m.view) {
      case 'x':
        this.posX = m.position.y;
        this.posY = m.position.z;
        break;
      case 'y':
        this.posX = m.position.x;
        this.posY = m.position.z;
        break;
      case 'z':
        this.posX = m.position.x;
        this.posY = m.position.y;
        break;
      default:
        this.posX = m.position.y;
        this.posY = m.position.z;
    }
  }
  // updatePos_bak(m: LineInputModel) {
  //   switch (this.viewInput) {
  //     case 'x':
  //       this.posX = m.position.y;
  //       this.posY = m.position.z;
  //       break;
  //     case 'y':
  //       this.posX = m.position.x;
  //       this.posY = m.position.z;
  //       break;
  //     case 'z':
  //       this.posX = m.position.x;
  //       this.posY = m.position.y;
  //       break;
  //     default:
  //       this.posX = m.position.y;
  //       this.posY = m.position.z;
  //   }
  // }
}
